import React, { memo } from 'react';

/**
 * Color scheme selector component
 */
const ColorSchemeSelector = memo(({ colorSchemes, selectedColorScheme, onSelect }) => {
  return (
    <div className="landing-color-schemes">
      {colorSchemes.map((scheme) => (
        <div
          key={scheme.id}
          className={`landing-color-scheme-option ${
            selectedColorScheme === scheme.id ? 'active' : ''
          }`}
          onClick={() => onSelect(scheme.id)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              onSelect(scheme.id);
            }
          }}
          tabIndex={0}
          role="button"
          aria-label={`Select ${scheme.name} color scheme`}
          aria-pressed={selectedColorScheme === scheme.id}
        >
          <div>
            <div className="landing-color-scheme-name">{scheme.name}</div>
          </div>
          <div className="landing-color-palette">
            {scheme.colors.map((color, index) => (
              <div
                key={index}
                className="landing-color-swatch"
                style={{ backgroundColor: color }}
                aria-label={`Color ${index + 1}: ${color}`}
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
});

ColorSchemeSelector.displayName = 'ColorSchemeSelector';

export default ColorSchemeSelector;

